<template>
  <div id="app" style="height:100%">
    <router-view />
  </div>
</template>

<script>
// import { mapMutations } from 'vuex'
// import axios from 'axios'
export default {
  name: 'App'
  // methods: {
  //   ...mapMutations(['setFloatingData'])
  // },
  // created() {
  //   axios.get('./static/data.json').then(res => {
  //     this.setFloatingData(res.data)
  //   })
  // }
}
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
}
#app {
  font-size: 14px;
  /* max-width: 1920px;
  margin: 0 auto;
  position: relative; */
}
* {
  user-select: none;
}
.swiper-button-prev:after {
  background-image: url('../static/img/hover-left.svg');
  color: transparent;
  width: 45px;
}
.swiper-button-next:after {
  background-image: url('../static/img/hover-right.svg');
  color: transparent;
  width: 45px;
}
.swiper-button-next,
.swiper-button-pre {
  width: 34px;
  height: 59px;
}
body *::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}

body *::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #928c8c;
}

body *::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue